module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.response) ? _c('div', [(_vm.isOWL) ? _c('document-container', {
    attrs: {
      "logo": _vm.logo,
      "documentType": "tmc-export"
    }
  }, [_c('div', {
    attrs: {
      "slot": "raw-header"
    },
    slot: "raw-header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('pagetitle', {
    attrs: {
      "data": {
        title: "Produktprüfung und Freigabe eines Finanzinstruments"
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table', {
    staticClass: "table is-narrow"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Datum")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(new Date().toLocaleDateString('de')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Empfehlung")]), _vm._v(" "), _c('td', [_vm._v("Kaufen")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Produktname")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.response[0].checkResult.product.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WKN / ISIN")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.response[0].checkResult.product.ids.wkn) + " / " + _vm._s(_vm.response[0].checkResult.product.ids.isin))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vorabprüfung auf vorliegende Interessenkonflikte zum Emittent, Produktintervention der BaFin\n          ")]), _vm._v(" "), _c('td', [_vm._v("Zu Emittenten BNP, DZ BANK HSBC, UBS, Vontobel vorab zentral erfolgt")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Marktmeinung/Begründung/Chancen")]), _vm._v(" "), _c('td', [_vm._v("Siehe Erläuterung in der Geeignetheitserklärung")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Risiken")]), _vm._v(" "), _c('td', [_vm._v(" Siehe PIF")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Anlageform/-rhythmus")]), _vm._v(" "), _c('td', [_vm._v("[     ] Einmalige Anlage")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Assetklasse")]), _vm._v(" "), _c('td', [_vm._v("100% Substanzwerte")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("PAI/ OffenlegVO/ TaxVO")]), _vm._v(" "), _c('td', [_vm._v(" Siehe Tabelle")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Prüfung von PIF/BIB\n          ")]), _vm._v(" "), _c('td', [_vm._v("durchgeführt\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bail-in-fähiges Finanzinstrument (Gläubigerbeteiligung)\n          ")]), _vm._v(" "), _c('td', [_vm._v("ja\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Äquivalenzprüfung")]), _vm._v(" "), _c('td', [_vm._v("Vorab systemseitig erfolgt")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n            Ergebnis der Zielmarktprüfung\n          ")]), _vm._v(" "), (_vm.response[0].checkResult.tmc.conflict) ? _c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm._v("Kriterien nicht erfüllt")]) : _vm._e(), _vm._v(" "), (!_vm.response[0].checkResult.tmc.conflict) ? _c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm._v("Kriterien erfüllt")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kundennummer")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px dashed #294b88"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.response[0].checkResult.comment || '—')), _c('br'), _c('br'), _vm._v("Hinweis zur Abwicklung: Textschlüssel 101_ außerhalb\n            der Hausmeinung nutzen. Ablage im Kundenarchiv\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('br'), _vm._v("Produktfreigabe erteilt\n          ")]), _vm._v(" "), _c('td', [_c('br'), _vm._v("Mitarbeiter / User-ID:\n          ")])])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.response), function(product) {
    return _c('document-container', {
      key: product.checkResult.product.ids.isin,
      attrs: {
        "logo": _vm.logo,
        "documentType": "tmc-export"
      }
    }, [_c('div', {
      attrs: {
        "slot": "raw-header"
      },
      slot: "raw-header"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": _vm.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "header"
    }, [(!_vm.isOWL) ? _c('pagetitle', {
      attrs: {
        "data": {
          title: product.checkResult.product.name || (product.checkResult.product.enriched ? product.checkResult.product.enriched.displayName : false) || product.checkResult.product.ids.isin
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isOWL) ? _c('pagetitle', {
      attrs: {
        "data": {
          title: "Produktprüfung und Freigabe eines Finanzinstruments"
        }
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticClass: "tmc-info"
    }, [_c('div', [_c('strong', [_vm._v("WKN:")]), _vm._v(" " + _vm._s(product.checkResult.product.ids.wkn) + "   |  \n          "), _c('strong', [_vm._v("ISIN:")]), _vm._v(" " + _vm._s(product.checkResult.product.ids.isin) + "   |  \n          "), _c('strong', [_vm._v("Stand:")]), _vm._v(" " + _vm._s(_vm.time) + "\n          "), (product.customData.name) ? [_vm._v("  |  \n            "), _c('strong', [_vm._v("Kunde:")]), _vm._v(" " + _vm._s(product.customData.name) + "\n          ")] : _vm._e()], 2), _vm._v(" "), (product.checkResult.tmc.displayInfoText) ? [_c('br'), _vm._v(" "), _c('i', {
      class: ("fa " + (product.checkResult.tmc.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'))
    }), _vm._v("\n          " + _vm._s(product.checkResult.tmc.info) + "\n        ")] : _vm._e()], 2), _vm._v(" "), _c('table', {
      staticClass: "table is-narrow"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(product.checkResult.product.label))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(product.checkResult.reference.label))])])]), _vm._v(" "), _c('tbody', _vm._l((product.checkResult.tmc.criteria), function(row) {
      return _c('tr', {
        class: row.conflict ? 'tmc-row-conflict' : 'tmc-row-success'
      }, [_c('td', [_c('i', {
        class: ("fa " + (row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'))
      }), _vm._v("\n             \n            " + _vm._s(row.label) + "\n          ")]), _vm._v(" "), _c('td', [_c('i', {
        staticClass: "fa fa-plus-circle",
        class: row.positive ? 'tmc-success' : 'tmc-neutral'
      }), _vm._v("\n            " + _vm._s(row.positive ? row.positive.join(', ') : '—') + "\n            "), _c('br'), _vm._v(" "), _c('i', {
        staticClass: "fa fa-minus-circle",
        class: row.negative ? 'tmc-error' : 'tmc-neutral'
      }), _vm._v("\n            " + _vm._s(row.negative ? row.negative.join(', ') : '—') + "\n          ")]), _vm._v(" "), (_vm.$route.query.mode === 'REFERENCE_TMC_GROUP') ? _c('td', [_c('i', {
        staticClass: "fa fa-plus-circle",
        class: row.referencePositive ? 'tmc-success' : 'tmc-neutral'
      }), _vm._v("\n            " + _vm._s(row.referencePositive ? row.referencePositive.join(', ') : '—') + "\n            "), _c('br'), _vm._v(" "), _c('i', {
        staticClass: "fa fa-minus-circle",
        class: row.referenceNegative ? 'tmc-error' : 'tmc-neutral'
      }), _vm._v("\n            " + _vm._s(row.referenceNegative ? row.referenceNegative.join(', ') : '—') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.mode === 'REFERENCE_PROVIDER' || _vm.$route.query.mode === 'CUSTOMER') ? _c('td', [(row.referencePositive) ? [_vm._v(_vm._s(row.referencePositive.join(', ')))] : [_vm._v("—")]], 2) : _vm._e()])
    }), 0)])]), _vm._v(" "), (['TMC_SUSTAINABILITY', 'TMC_SUSTAINABILITY_SUITABILITY'].includes(product.checkVisibilityMode)) ? _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticClass: "tmc-info"
    }, [(product.checkResult.sustainability.displayInfoText) ? [_c('i', {
      class: ("fa " + (product.checkResult.sustainability.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'))
    }), _vm._v("\n          " + _vm._s(product.checkResult.sustainability.info) + "\n        ")] : _vm._e()], 2), _vm._v(" "), _c('table', {
      staticClass: "table is-narrow"
    }, [_c('thead', [(_vm.environment === 'hauck') ? _c('tr', [_c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Kategorie")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("Ausprägung Produkt")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(product.checkResult.reference.label))])]) : _c('tr', [_c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("Kriterien")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(product.checkResult.reference.label))])])]), _vm._v(" "), _c('tbody', _vm._l((product.checkResult.sustainability.criteria), function(row) {
      return _c('tr', {
        class: row.conflict ? 'tmc-row-conflict' : 'tmc-row-success'
      }, [_c('td', [_c('i', {
        class: ("fa " + (row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'))
      }), _vm._v(" " + _vm._s(row.label) + "\n          ")]), _vm._v(" "), _c('td', [(row.criteria && row.criteria.length !== 0) ? _vm._l((row.criteria), function(cell) {
        return _c('div', [_vm._v(_vm._s(cell))])
      }) : [_vm._v("—")]], 2), _vm._v(" "), _c('td', [(row.reference && row.reference.length !== 0) ? _vm._l((row.reference), function(cell) {
        return _c('div', [_vm._v(_vm._s(cell))])
      }) : [_vm._v("—")]], 2)])
    }), 0)])]) : _vm._e(), _vm._v(" "), ('TMC_SUSTAINABILITY_SUITABILITY' === product.checkVisibilityMode) ? _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticClass: "tmc-info"
    }, [(product.checkResult.suitability.displayInfoText) ? [_c('i', {
      class: ("fa " + (product.checkResult.suitability.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'))
    }), _vm._v("\n          " + _vm._s(product.checkResult.suitability.info) + "\n        ")] : _vm._e()], 2), _vm._v(" "), _c('table', {
      staticClass: "table is-narrow"
    }, [_c('thead', [(_vm.environment === 'hauck') ? _c('tr', [_c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("Wertpapierrisikoklasse")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(product.checkResult.reference.label))])]) : _c('tr', [_c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("Kriterien")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(product.checkResult.reference.label))])])]), _vm._v(" "), _c('tbody', _vm._l((product.checkResult.suitability.criteria), function(row) {
      return _c('tr', {
        class: row.conflict ? 'tmc-row-conflict' : 'tmc-row-success'
      }, [_c('td', [_c('i', {
        class: ("fa " + (row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'))
      }), _vm._v("\n             \n            " + _vm._s(row.label) + "\n          ")]), _vm._v(" "), _c('td', [(row.criteria && row.criteria.length !== 0) ? [_vm._v(_vm._s(row.criteria.join(', ')))] : [_vm._v("—")]], 2), _vm._v(" "), _c('td', [(row.reference && row.reference.length !== 0) ? [_vm._v(_vm._s(row.reference.join(', ')))] : [_vm._v("—")]], 2)])
    }), 0)])]) : _vm._e(), _vm._v(" "), (product.esgPropertiesAreVisible) ? _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('h2', [_vm._v("Nachhaltigkeit")]), _vm._v(" "), _c('table', {
      staticClass: "table is-narrow"
    }, _vm._l((_vm.esgTranslations), function(value, key) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(value))]), _vm._v(" "), (key !== 'paiCluster') ? _c('td', [_vm._v(_vm._s(product.checkResult.product.sustainability[key] || '—'))]) : _vm._e(), _vm._v(" "), (key === 'paiCluster') ? _c('td', {
        domProps: {
          "innerHTML": _vm._s(product.checkResult.product.sustainability[key].join('<br>') || '---')
        }
      }) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isOWL) ? _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('h2', [_vm._v("Kommentar")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(product.checkResult.comment || '---'))])]) : _vm._e()])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b713de24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmc-export/TmcExport.vue
// module id = 716
// module chunks = 0